import React, { useEffect, useRef, useState, forwardRef } from 'react';
import { formatData } from '../../../helpers';
import { useTooltip } from '../../../hooks';

const _SideDialogSearchResult = (
  { item, title, subtitle, description, photo, selected = false, onClick },
  ref
) => {
  const { showTooltip, hideTooltip } = useTooltip();

  const handleClick = () => {
    onClick && onClick(item);
  };

  return (
    <div
      className={'side-dialog-search-result' + (selected ? ' selected' : '')}
      onClick={handleClick}
      onMouseEnter={() => showTooltip({ title: title, bodyText: description })}
      onMouseLeave={() => hideTooltip()}
    >
      {photo && <div className="side-dialog-search-result-photo">{photo}</div>}
      <div className="side-dialog-search-result-body">
        <div className="side-dialog-search-result-title">{title}</div>
        {subtitle && <div className="side-dialog-search-result-subtitle">{subtitle}</div>}
      </div>
      {selected && <div className="side-dialog-search-result-selected">selected</div>}
    </div>
  );
};

export const SideDialogSearchResult = forwardRef(_SideDialogSearchResult);
